export default "__VITE_ASSET__12ab53cd__"